import { useUserStore } from '@/stores/user';
import { useExchangeStore } from '@/stores/exchange';
import { useMiscStore } from '@/stores/store';
import { useAuthStore } from '@/stores/auth';
export function resetAllStores() {
  const userStore = useUserStore();
  const authStore = useAuthStore();
  const exchangeStore = useExchangeStore();
  const miscStore = useMiscStore();
  userStore.reset();
  authStore.reset();
  exchangeStore.reset();
  miscStore.reset();
}
